<form [formGroup]="widgetForm">
    <div formArrayName="formChildren" class="wrapper">
        <h1>Widget test screen</h1>
        <h2>Low-level components</h2>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Checkbox to enable/disable inputs</label>
            <div class="col-4">
                <pace-core-checkbox-input
                    [(model)]="checkboxInputToggleTest"
                    (valueChange)="onCheckboxInputToggleChange()"
                    [parentForm]="formChildren"
                ></pace-core-checkbox-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(checkboxInputToggleTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Text input (pattern <code>Initial.*</code>, length 5-10)</label>
            <div class="col-4">
                <pace-core-text-input
                    [(model)]="textInputTest"
                    (valueChange)="onTextInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(textInputTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Text input (scannable, length 5-10)</label>
            <div class="col-4">
                <pace-core-text-input
                    [(model)]="textInputScannableTest"
                    (valueChange)="onTextInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(textInputScannableTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Text input (with unit, length 5-10)</label>
            <div class="col-4">
                <pace-core-text-input
                    [(model)]="textInputUnitTest"
                    (valueChange)="onTextInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(textInputUnitTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Text input (readonly)</label>
            <div class="col-4">
                <pace-core-text-input
                    [(model)]="textInputReadonlyTest"
                    (valueChange)="onTextInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(textInputReadonlyTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Number input</label>
            <div class="col-4">
                <pace-core-number-input
                    [(model)]="numberInputTest"
                    (valueChange)="onNumberInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-number-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(numberInputTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Number input (with unit + scannable)</label>
            <div class="col-4">
                <pace-core-number-input
                    [(model)]="numberInputScannableTest"
                    (valueChange)="onNumberInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-number-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(numberInputScannableTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Number stepper</label>
            <div class="col-4">
                <div class="col-lg-6 col-10">
                    <pace-core-number-stepper
                        [(model)]="numberStepperTest"
                        (valueChange)="onNumberStepperChange($event)"
                        [parentForm]="formChildren"
                    ></pace-core-number-stepper>
                </div>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(numberStepperTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Rating input</label>
            <div class="col-4">
                <pace-core-rating-input
                    [(model)]="ratingInputTest"
                    (valueChange)="onRatingInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-rating-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(ratingInputTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Duration stepper</label>
            <div class="col-4">
                <pace-core-duration-stepper
                    [(model)]="durationStepperTest"
                    (valueChange)="onDurationStepperChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-duration-stepper>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(durationStepperTest)">OData</button>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-3 col-form-label">Duration stepper with step value 5</label>
            <div class="col-4">
                <pace-core-duration-stepper
                    [(model)]="durationStepperStepTest"
                    (valueChange)="onDurationStepperChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-duration-stepper>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(durationStepperStepTest)">OData</button>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-3 col-form-label">Duration stepper without value</label>
            <div class="col-4">
                <pace-core-duration-stepper
                    [(model)]="durationStepperUndefinedTest"
                    (valueChange)="onDurationStepperChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-duration-stepper>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(durationStepperUndefinedTest)">OData</button>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-3 col-form-label"
                >Duration stepper (minValue: {{ durationStepperMaxValueTest.options.minValue.asMinutes() }}, maxValue:
                {{ durationStepperMaxValueTest.options.maxValue.asMinutes() }} minutes)</label
            >
            <div class="col-4">
                <pace-core-duration-stepper
                    [(model)]="durationStepperMaxValueTest"
                    (valueChange)="onDurationStepperChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-duration-stepper>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(durationStepperMaxValueTest)">OData</button>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-3 col-form-label">Date input</label>
            <div class="col-4">
                <pace-core-date-input
                    [(model)]="dateInputTest"
                    (valueChange)="onDateInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-date-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(dateInputTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Time input</label>
            <div class="col-4">
                <pace-core-time-input
                    [(model)]="timeInputTest"
                    (valueChange)="onTimeInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-time-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(timeInputTest)">OData</button>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-3 col-form-label">Date-time input (min: start of hour, max: end of day)</label>
            <div class="col-4">
                <pace-core-datetime-input
                    [(model)]="dateTimeInputTest"
                    (valueChange)="onDateTimeInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-datetime-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(dateTimeInputTest)">OData</button>
            </div>
        </div>

        <div class="row mb-3">
            <label class="col-3 col-form-label">Dropdown (single-select)</label>
            <div class="col-4">
                <pace-core-dropdown
                    [(model)]="dropdownTest"
                    (valueChange)="onDropdownChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-dropdown>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(dropdownTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Dropdown with text input (single-select)</label>
            <div class="col-4">
                <pace-core-dropdown
                    [(model)]="dropdownInputTest"
                    (valueChange)="onDropdownChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-dropdown>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(dropdownTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Dropdown (disabled)</label>
            <div class="col-4">
                <pace-core-dropdown
                    [(model)]="dropdownDisabledTest"
                    (valueChange)="onDropdownChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-dropdown>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(dropdownDisabledTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Dropdown (multi-select)</label>
            <div class="col-4">
                <pace-core-dropdown
                    [(model)]="dropdownMultiTest"
                    (valueChange)="onDropdownChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-dropdown>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(dropdownMultiTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Radio buttons</label>
            <div class="col-4">
                <pace-core-radio-input
                    [(model)]="radioInputTest"
                    (valueChange)="onRadioInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-radio-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(radioInputTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Checkbox</label>
            <div class="col-4">
                <pace-core-checkbox-input
                    [(model)]="checkboxInputTest"
                    (valueChange)="onCheckboxInputChange($event)"
                    [parentForm]="formChildren"
                ></pace-core-checkbox-input>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(checkboxInputTest)">OData</button>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-3 col-form-label">Tree view</label>
            <div class="col-4">
                <pace-core-tree-view
                    [(model)]="treeViewTest"
                    [parentForm]="formChildren"
                    (valueChange)="onTreeviewInputChange()"
                ></pace-core-tree-view>
            </div>
            <div class="col-2">
                <button class="btn btn-secondary" (click)="showOutmodel(treeViewTest)">OData</button>
            </div>
        </div>
        <h2>High-level components</h2>
        <div class="row mb-3">
            <label class="col-3 col-form-label">App reinitialization</label>
            <div class="col-2">
                <button
                    class="btn btn-secondary"
                    (click)="startInitApp()"
                    [disabled]="appReinitializationRunning || serviceReinitializationRunning"
                >
                    App init
                </button>
            </div>
            <div class="col-2">
                <button
                    class="btn btn-secondary"
                    (click)="startInitServices()"
                    [disabled]="appReinitializationRunning || serviceReinitializationRunning"
                >
                    Service init
                </button>
            </div>
        </div>
    </div>
</form>
